import {Box, Breadcrumbs, Link, makeStyles, Typography} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import React, {FC} from "react";
import styled from "styled-components/macro";
import {Skeleton as MuiSkeleton} from "@material-ui/lab";
import {Fade} from "@mui/material";

const useStyles = makeStyles(() => ({
  linkItem: {
    textDecoration: "none",
    color: "inherit",
    // '&:hover': {
      // textDecoration: "none!important"
    // },
  },
  current: {
    '&:hover': {
      textDecoration: "none!important"
    },
    textDecoration: "none",
    background: "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)!important",
    "-webkit-background-clip": "text!important",
    "-webkit-text-fill-color": "transparent!important"
  }
}))


const Skeleton = styled(MuiSkeleton)`
  background-color: #232F3E;
  max-width: 100px;
`

type PropsType = {
  current: string,
  before: { to: string, title: string }[]
}

const CustomBreadcrumbs: FC<PropsType> = ({current, before}) => {
  const styles = useStyles()

  return (
    <Box mt={1}>
      <Breadcrumbs aria-label="Breadcrumb">
        {before.map((item, index) => (
          <Link key={index} component={NavLink} exact to={item.to} className={styles.linkItem}>
            {item.title}
          </Link>
        ))}
        {current ? (
          <Fade in={true}>
            <Typography className={styles.current}>
              {current}
            </Typography>
          </Fade>
        ) : (
          <Skeleton variant='text' width={80}/>
        )}
      </Breadcrumbs>
    </Box>
  )
}

export default CustomBreadcrumbs
